<div class="component-container flex flex-col">

  <!-- /********** NAME SECTION **********/-->

  <div
    *ngIf="profileLoader; else nameSection"
    class="name-section-loader flex flex-row
           justify-start items-center gap-[0.8rem]"
  >
    <app-shimmer-loader
      [theme]="{
            'height': '3rem',
            'width': '3rem'
          }"
      appearance="circle"
      class="circle"
    ></app-shimmer-loader>
    <app-shimmer-loader
      [count]="1"
      [theme]="{'height': '3rem'}"
      appearance="line"
      class="line w-[30%]"
    ></app-shimmer-loader>
  </div>
  <ng-template #nameSection>
    <div
      class="name-section flex flex-row
           justify-start items-center
           gap-[0.8rem]"
    >
      <div
        class="profile-image flex flex-row
              justify-center items-center {{!profile?.avatar?.url ?
              'p-[1.5rem]' : 'p-0'}} "
      >
        <app-image
          *ngIf="profile['avatar']?.url; else tempAvatar"
          [url]="profile['avatar']?.url"
        ></app-image>
        <ng-template #tempAvatar>
          {{ profileAvatar | uppercase }}
        </ng-template>
      </div>
      <div class="name">
        {{ profile?.firstName | titlecase }} {{ profile?.lastName | titlecase }} {{ 'Profile' }}
        <span
          *ngIf="profile?.role === roles?.participant && profile?.age"
        >
        , {{ profile?.age }}
      </span>
      </div>
    </div>
  </ng-template>
  <hr class="hr line-break">

  <div
    *ngIf="profileLoader; else displayProfile"
    class="shimmer-loader"
  >
    <app-user-details-shimmer-loader></app-user-details-shimmer-loader>
  </div>
  <ng-template #displayProfile>
    <div class="profile-data w-full">
      <!-- /********** USER DETAILS SECTION **********/-->

      <div class="user-details-section flex flex-col justify-center items-center">
        <div
          class="section-heading flex flex-row
               justify-start items-center"
        >
          Personal Details
        </div>
        <app-non-editable-user-details
          (handleClick)="editUserDetailsView()"
          *ngIf="!editUserDetails;else editableUserSection"
          [hasUserId]=hasUserId
          [loggedInUserRole]="loggedInUserRole"
          [userDetails]="profile"
          class="non-editable-user-details w-10/12 flex justify-center items-center"
        >
        </app-non-editable-user-details>
        <ng-template #editableUserSection>
          <app-editable-user-details
            (handleClick)="editUserDetailsView()"
            [hasUserId]=hasUserId
            [loggedInUserRole]="loggedInUserRole"
            [userDetails]="profile"
            class="editable-user-details w-10/12 flex justify-center items-center"
          >
          </app-editable-user-details>
        </ng-template>
      </div>
      <hr class="hr line-break">
      <!-- /********** ONBOARDING DETAILS SECTION **********/-->
      <div
        *ngIf="profile?.role > roles['superAdmin'] "
        class="onboarding-section flex flex-col justify-center items-center"
      >
        <div
          class="section-heading flex flex-row
               justify-start items-center"
        >
          Onboarding Details
        </div>

        <app-non-editable-onboarding-details
          (handleClick)="editOnboardingDetailsView($event)"
          *ngIf="!editOnboardingDetails;else editableOnboardingSection"
          [userDetails]="profile"
          class="non-editable-user-details w-10/12 flex justify-center items-center"
        >
        </app-non-editable-onboarding-details>
        <ng-template #editableOnboardingSection>
          <app-editable-onboarding-details
            (handleClick)="editOnboardingDetailsView($event)"
            [userDetails]="profile"
            class="editable-user-details w-10/12 flex justify-center items-center"
          >
          </app-editable-onboarding-details>
        </ng-template>
      </div>
      <hr
        *ngIf="profile?.role > roles['superAdmin'] "
        class="hr line-break"
      >
      <!-- /********** ORGANIZATION DETAILS SECTION **********/-->
      <div
        *ngIf="profile?.role > roles['superAdmin'] && profile?.role <= roles['participant'] "
        class="clinic-details-section flex flex-col justify-center items-center"
      >
        <div
          class="section-heading flex flex-row
               justify-start items-center"
        >
          Organization Details
        </div>

        <app-clinic-details
          [loading]="profileLoader"
          [userDetails]="profile"
          class="editable-user-details w-10/12 flex justify-center items-center"
        ></app-clinic-details>
      </div>
      <hr
        *ngIf="profile?.role > roles['superAdmin'] && profile?.role <=
    roles['participant'] "
        class="hr line-break"
      >
      <!-- /********** GROUP DETAILS SECTION **********/-->
      <div
        *ngIf="profile?.role === roles['participant']"
        class="group-details-section flex flex-col justify-center items-center"
      >
        <div
          class="section-heading flex flex-row
               justify-start items-center"
        >
          Group Details
        </div>

        <app-group-details
          [loading]="profileLoader"
          [userDetails]="profile"
          class="editable-user-details w-10/12 flex justify-center items-center"
        ></app-group-details>
      </div>
      <hr
        *ngIf="profile?.role === roles['participant']"
        class="hr line-break"
      >
      <!-- /********** ADULT DETAILS SECTION **********/-->
      <div
        *ngIf="profile?.role === roles['adult']"
        class="participant-details-section flex flex-col justify-center items-center"
      >
        <div
          class="section-heading flex flex-row
               justify-start items-center"
        >
          Participant Details
        </div>

        <app-participant-details
          [loading]="profileLoader"
          [loggedInUserRole]="loggedInUserRole"
          [userDetails]="profile"
          class="editable-user-details w-10/12 flex justify-center items-center"
        ></app-participant-details>
      </div>
      <!-- /********** PARTICIPANT DETAILS SECTION **********/-->
      <div
        *ngIf="profile?.role === roles['participant']"
        class="adult-details-section flex flex-col justify-center items-center"
      >
        <div
          class="section-heading flex flex-row
               justify-start items-center"
        >
          Adult Details
        </div>

        <app-adult-details
          (handleClick)="editAdultDetailsView()"
          [loading]="profileLoader"
          [userDetails]="profile"
          [loggedInUserRole]="loggedInUserRole"
          [isEditMode]="editAdultDetails"
          [hasUserId]="hasUserId"
          class="editable-user-details w-10/12 flex justify-center items-center"
        ></app-adult-details>
      </div>
    </div>
  </ng-template>
</div>
